import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ViewSettingsTab from './ViewSettingsTab';

interface AppearanceDialogProps {
  open: boolean;
  onClose: () => void;
}

const AppearanceDialog: React.FC<AppearanceDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 5 }}>
        Wygląd
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <ViewSettingsTab />
      </DialogContent>
    </Dialog>
  );
};

export default AppearanceDialog;


